export const headCells = [
    {
        id: 'customerDesc',
        label: 'Customer',
        sortingRequired: true,
    },
    {
        id: 'division',
        label: 'District',
        sortingRequired: true,
    },
    {
        id: 'itemid',
        label: 'Item ID',
        sortingRequired: true,
    },
    {
        id: 'itemdesc',
        label: 'Item Desc',
        sortingRequired: true,
    },
    {
        id: 'l4',
        label: 'Category',
        sortingRequired: true,
    },
    {
        id: 'quantity',
        label: 'Quantity (eaches/year)',
        sortingRequired: true,
    },
    {
        id: 'revenue',
        label: 'Revenue ($/year)',
        sortingRequired: true,
    },
    {
        id: 'peerPrice',
        label: 'Target Price ($)',
        sortingRequired: true,
    },
    {
        id: 'currentPrice',
        label: 'Current Price ($)',
        sortingRequired: true,
    },
    {
        id: 'adjustedPrice',
        label: 'Adjusted Price ($)',
        sortingRequired: true,
    },
    {
        id: 'opportunity',
        label: 'Opportunity ($)',
        sortingRequired: true,
    },
    {
        id: 'action',
        label: 'Action',
        sortingRequired: false,
    },
];